import { useCallback } from "react";
import { useUserPreferences } from "./useUserPreferences";

/**
 * Whether the user has dismissed the org chart "Edit Controls" help panel.
 * Persisted so the panel stops auto-opening on future edit-mode entries.
 */
export const useUserOrgChartEditControls = () => {
  const {
    mergedPreferences,
    globalUserPreferences,
    updatePreferencesForGlobalUser,
  } = useUserPreferences();

  const setDismissed = useCallback(
    async (dismissed: boolean): Promise<boolean> =>
      updatePreferencesForGlobalUser({
        ...globalUserPreferences,
        orgChartEditControls: {
          ...globalUserPreferences?.orgChartEditControls,
          dismissed,
        },
      }),
    [globalUserPreferences, updatePreferencesForGlobalUser]
  );

  return {
    dismissed: mergedPreferences?.orgChartEditControls?.dismissed ?? false,
    setDismissed,
  };
};
